import { Translation, QRType } from '../types';

export const es: Translation = {
  nav: {
    generator: 'Generador',
    scanner: 'Escáner',
    mobile: 'Probar en el móvil',
    blog: 'Blog',
    langSelect: 'Seleccionar idioma',
  },
  pageTitles: {
    generator: 'Generador de Códigos QR Gratis Online',
    scanner: 'Escáner de Códigos QR Online',
    textToQr: 'Convertir Texto a Código QR',
    linkToQr: 'Generador de Código QR para Enlaces',
  },
  pageMeta: {
    generator: {
      title:
        'Generador de Códigos QR Gratis — Crea QR en Línea (Sin Registro, Sin Marca de Agua, PNG/SVG/PDF) | YesQRCode',
      description:
        'Crea códigos QR online gratis con YesQRCode. Genera URLs, texto, WiFi, vCard y más. Descarga PNG, SVG o PDF en alta calidad. Sin registro, sin inicio de sesión, sin marca de agua: rápido, seguro y siempre gratis.',
      keywords: [
        'generador de códigos qr',
        'generador de qr gratis',
        'crear código qr online',
        'creador de qr',
        'qr code png',
        'qr code svg',
        'qr code pdf',
        'generador de qr wifi',
        'generador de qr vcard',
        'generador de qr sin registro',
      ],
    },
    scanner: {
      title:
        'Lector de Códigos QR en Línea — Escanea desde Imagen o Cámara (Seguro, Sin Registro) | YesQRCode',
      description:
        'Escanea códigos QR y códigos de barras online gratis. Sube una imagen o usa tu cámara. Todo se procesa localmente sin subir archivos. Seguro, rápido, sin registro, sin inicio de sesión y totalmente gratuito.',
      keywords: [
        'lector de códigos qr',
        'escanear código qr online',
        'lector qr online',
        'escanear qr desde imagen',
        'escanear código de barras online',
        'lector qr seguro',
        'lector qr sin subir archivos',
        'scanner qr gratis',
        'lector qr en el navegador',
        'scanner qr sin registro',
      ],
    },
    textToQr: {
      title: 'Convertidor de Texto a Código QR — Convierte texto en QR al instante | YesQRCode',
      description:
        'Convierte fragmentos de texto, notas o mensajes en códigos QR online. Personaliza colores, marcos y logotipos y descarga PNG, SVG o PDF de alta calidad sin registro.',
      keywords: [
        'texto a codigo qr',
        'convertir texto a qr',
        'generador qr de texto',
        'qr de texto online',
        'mensaje a codigo qr',
        'nota a qr',
        'qr de texto gratis',
        'texto qr sin registro',
        'qr code para texto',
        'text qr en español',
      ],
    },
    linkToQr: {
      title: 'Generador de Enlace a Código QR — Convierte URLs en QR (Compatible con UTM) | YesQRCode',
      description:
        'Pega cualquier URL de sitio o campaña y obtén un QR personalizado al instante. Colores, logotipos y descargas PNG/SVG/PDF en alta resolución sin inicio de sesión.',
      keywords: [
        'enlace a codigo qr',
        'convertir url a qr',
        'generador qr para enlaces',
        'qr para sitio web',
        'qr para url',
        'qr utm',
        'link qr gratis',
        'qr para campañas',
        'url qr sin registro',
        'qr de enlaces online',
      ],
    },
  },
  hero: {
    title: 'Generar. Escanear. Crear.',
    subtitle: 'La herramienta premium de códigos QR para todos.',
    desc: 'Crea códigos QR personalizados con logotipos, colores y archivos de alta resolución al instante.',
  },
  info: {
    helpTitle: 'Centro de Ayuda',
    helpSubtitle: 'Preguntas frecuentes y soporte',
    contactTitle: 'Contáctanos',
    contactSubtitle: 'Estamos listos para ayudarte.',
    privacyTitle: 'Política de Privacidad',
    termsTitle: 'Términos de Servicio',
  },
  contactForm: {
    name: 'Nombre',
    email: 'Correo electrónico',
    message: 'Mensaje',
    send: 'Enviar mensaje',
    orEmail: 'o escribe directamente a',
    sending: 'Enviando...',
    successTitle: '¡Mensaje enviado!',
    successMessage: 'Gracias por tu mensaje. Nos pondremos en contacto pronto.',
    sendAnother: 'Enviar otro mensaje',
    errorMessage: 'No pudimos enviar tu mensaje. Escríbenos a support@yesqrcode.com.',
  },
  generator: {
    highlights: {
      title: 'Crea códigos QR privados y listos para tu marca — gratis para siempre.',
      subtitle: 'Una herramienta rápida, privada y flexible para cualquier flujo de trabajo.',
      desc: 'Genera y escanea códigos QR de alta calidad sin cuentas, marcas de agua ni cargas.',
      items: [
        {
          title: 'Privacidad ante todo, generación local',
          desc: 'Los QR se crean en tu dispositivo — sin subidas, rastreo ni almacenamiento.',
        },
        {
          title: 'Funciones para cada caso de uso',
          desc: 'URL, WiFi, vCard, códigos de barras, logos, degradados y marcos incluidos.',
        },
        {
          title: 'Experiencia móvil para todos',
          desc: 'Interfaz optimizada para teléfonos y gestos táctiles para crear y escanear sin fricción.',
        },
        {
          title: 'Gratis para siempre y apto para negocios',
          desc: 'Sin cuentas, sin marcas de agua y sin límites de escaneo — fiable para equipos y marcas.',
        },
      ],
    },
    featureSuite: {
      title: 'La suite completa de QR centrada en la privacidad',
      subtitle: 'Todo lo necesario para crear QR limpios, con marca y de alta calidad en un solo lugar.',
      categories: [
        {
          title: 'Todos los tipos de QR que necesitas',
          body: 'URL, texto, WiFi, correo, teléfono, SMS, vCard, enlaces sociales, YouTube y códigos de barras. Códigos estáticos que no caducan.',
          items: [],
        },
        {
          title: 'Branding y diseño',
          body: 'Códigos seguros para logos, degradados, marcos, formas, esquinas y layouts optimizados para el escaneo.',
          items: [],
        },
        {
          title: 'Salida y calidad',
          body: 'Exportaciones PNG, SVG y PDF en alta resolución con ajustes para impresión y digital.',
          items: [],
        },
        {
          title: 'Global y usabilidad',
          body: 'Interfaz multilingüe, diseño mobile-first y flujo compatible sin conexión.',
          items: [],
        },
      ],
    },
    trust: {
      title: 'Trusted by creators, teams, and brands',
      subtitle:
        'YesQRCode is designed to be lightweight, predictable, and safe for long-running campaigns — with no accounts, no vendor lock-in, and no hidden limitations.',
      items: [
        'Zero onboarding',
        'Predictable static codes',
        'Enterprise-safe: no cloud processing',
        'Consistent branding across all assets',
      ],
    },
    sectionContent: 'Contenido',
    sectionColors: 'Colores',
    sectionLogo: 'Logo',
    sectionFrame: 'Marco',
    sectionDesign: 'Diseño',
    sectionCorrection: 'Corrección de error',
    labelUrl: 'URL del sitio',
    labelText: 'Texto plano',
    labelSsid: 'Nombre de red (SSID)',
    labelPassword: 'Contraseña',
    labelEncryption: 'Cifrado',
    labelFgColor: 'Color principal',
    labelBgColor: 'Color de fondo',
    labelFrameText: 'Texto del marco',
    labelFrameColor: 'Color del marco',
    placeholder: 'Escribe el contenido aquí...',
    placeholders: {
      url: 'https://ejemplo.com',
      text: 'Escribe tu texto',
      email: 'tu@email.com',
      subject: 'Asunto',
      message: 'Tu mensaje...',
      phone: '+34 600 000 000',
      ssid: 'MiRed',
      password: 'Contraseña',
      barcode: '123456789012',
    },
    download: 'Descargar PNG',
    downloadSvg: 'Descargar SVG',
    generateButton: 'Generar código QR',
    copy: 'Copiar SVG',
    uploadLogo: 'Subir imagen',
    preview: 'Vista previa',
    lowQuality: 'Baja calidad',
    highQuality: 'Alta calidad',
    foreverFree: 'Gratis para siempre • Sin registro • Uso comercial permitido',
    barcodeWarning: 'Las opciones avanzadas como logotipo o marcos no están disponibles para códigos de barras.',
    barcodeColors: 'Aún puedes personalizar los colores abajo.',
    frameStyles: {
      none: 'Sin marco',
      simple: 'Simple',
      balloon: 'Burbuja',
      box: 'Caja',
      badge: 'Insignia',
      polaroid: 'Polaroid',
      phone: 'Teléfono',
      header: 'Encabezado',
      corner: 'Esquina',
    },
    vCard: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      mobile: 'Móvil',
      phone: 'Teléfono',
      fax: 'Fax',
      email: 'Correo',
      company: 'Empresa',
      job: 'Cargo',
      street: 'Calle',
      city: 'Ciudad',
      zip: 'Código postal',
      state: 'Provincia',
      country: 'País',
      website: 'Sitio web',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'Texto',
      [QRType.EMAIL]: 'Correo',
      [QRType.PHONE]: 'Teléfono',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi-Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'Código de barras',
    },
    guide: {
      title: '¿Cómo crear un QR personalizado?',
      steps: [],
    },
    gettingStarted: {
      title: 'Empieza en 4 pasos',
      steps: [
        {
          title: 'Define el contenido',
          text: 'Elige el tipo de QR (URL, texto, correo, Wi-Fi, etc.) y completa los campos que verán tus usuarios.',
        },
        {
          title: 'Personaliza el diseño',
          text: 'Cambia colores, formas y agrega tu logotipo para alinear el QR con tu identidad visual.',
        },
        {
          title: 'Genera el QR',
          text: 'Selecciona la resolución, revisa la vista previa y prueba el código con el escáner integrado.',
        },
        {
          title: 'Descarga y comparte',
          text: 'Exporta el archivo en PNG o SVG listo para campañas impresas o digitales.',
        },
      ],
    },
    about: {
      title: 'El generador de QR gratuito para usos profesionales',
      subtitle:
        'YesQRCode ofrece calidad para impresión, opciones visuales avanzadas y QR estáticos sin fecha de caducidad.',
      features: [
        'QR para redes sociales y landing pages',
        'vCard y tarjetas de visita digitales',
        'Compatibilidad con campañas de marketing',
        'Personalización total de colores y formas',
        'Archivos listos para impresión de gran formato',
        'Escaneos ilimitados sin coste',
      ],
      content: [
        {
          title: 'Vida útil infinita',
          body: 'Los QR son estáticos y no expiran. Crea uno y úsalo indefinidamente sin límites de escaneo.',
        },
        {
          title: 'QR con logotipo',
          body: 'Aprovecha hasta 30% de corrección de errores para colocar tu logotipo sin perder legibilidad.',
        },
        {
          title: 'Diseño completo',
          body: 'Configura esquinas, patrones, gradientes y marcos que hagan tu QR más atractivo.',
        },
        {
          title: 'Calidad de impresión',
          body: 'Descarga PNG de alta resolución o SVG vectorial para catálogos, envases y señalética.',
        },
        {
          title: 'Uso comercial permitido',
          body: 'Utiliza los códigos en campañas pagadas, empaques y proyectos corporativos sin restricciones.',
        },
      ],
    },
    faq: {
      title: 'Preguntas frecuentes',
      items: [
        {
          q: '¿Qué es un código QR?',
          a: 'Es un código bidimensional creado en 1994 que almacena texto, enlaces u otra información.',
        },
        {
          q: '¿Los QR generados son gratuitos?',
          a: 'Sí, puedes crear y usar todos los que necesites para proyectos personales o comerciales.',
        },
        {
          q: '¿Puedo editar el QR después?',
          a: 'Los códigos son estáticos; si necesitas cambios deberás generar un nuevo QR.',
        },
        {
          q: '¿Existe un límite de escaneos?',
          a: 'No, puedes recibir escaneos ilimitados sin coste adicional.',
        },
        {
          q: '¿Guardan mi información?',
          a: 'No. Solo almacenamos temporalmente las imágenes para optimizar las descargas.',
        },
        {
          q: '¿Por qué mi vCard no se muestra bien?',
          a: 'Algunos lectores no siguen el estándar vCard. Prueba con otra app de escaneo.',
        },
        {
          q: 'Mi QR no funciona, ¿qué hago?',
          a: 'Verifica que no haya errores en la URL, asegura buen contraste (fondo claro y frente oscura) y prueba sin logotipo.',
        },
        {
          q: '¿Funciona en todos los navegadores?',
          a: 'Sí, recomendamos Chrome, Firefox, Safari o Edge actualizados.',
        },
      ],
    },
  },
  scanner: {
    title: 'Escanear QR y códigos de barras',
    subtitle: 'Escanea desde cámara, sube una imagen o pega desde tu portapapeles.',
    cameraPermission: 'Activa el permiso de cámara en tu navegador para continuar.',
    result: 'Resultado',
    copy: 'Copiar',
    copied: 'Copiado',
    open: 'Abrir enlace',
    delete: 'Eliminar',
    scanAgain: 'Escanear otro',
    privacy: 'El procesamiento ocurre localmente. Los archivos no se envían a nuestros servidores.',
    upload: 'Subir imagen',
    paste: 'Pegar (Ctrl+V)',
    drop: 'Arrastra la imagen aquí',
    retry: 'Reintentar',
    errorAccessDenied: 'Acceso a la cámara denegado',
    errorCamera: 'Permite el uso de la cámara en la configuración del navegador.',
    initializing: 'Iniciando cámara...',
    cameraActive: 'Cámara activa',
    scannedItems: 'Escaneos',
    recentScans: 'Recientes (guardados localmente)',
    clickToUpload: 'Haz clic para subir',
    newBadge: 'NUEVO',
    tabCameraMobile: 'Cámara',
    tabCameraDesktop: 'Escanear con cámara',
    emptyState: {
      title: 'Aún no hay escaneos',
      desc: 'Sube una imagen o abre la pestaña de cámara para empezar.',
    },
    highlights: {
      title: 'Escaneo rápido y privado',
      items: [
        { title: 'Decodificación en el dispositivo', desc: 'Sin cargas por defecto; seguro para URLs y archivos sensibles.' },
        { title: 'Multiformato', desc: 'QR más UPC/EAN, Code 128, ITF y otros estándares.' },
        { title: 'Acciones rápidas', desc: 'Suelta archivos, pega capturas o cambia al escaneo en vivo al instante.' },
        { title: 'Excelente en móviles', desc: 'UI y flujo de cámara optimizados para teléfonos y pantallas pequeñas.' },
      ],
    },
    intro: {
      title: 'Escáner online seguro',
      body: 'Decodifica QR Codes, UPC, EAN, ITF y más directamente en tu navegador.',
    },
    howTo: {
      title: 'Cómo escanear',
      methods: [
        {
          title: 'Método 1: Subir imagen',
          steps: ['Haz clic en “Subir imagen”', 'Selecciona el archivo', 'Obtén el resultado al instante'],
        },
        {
          title: 'Método 2: Cámara',
          steps: ['Abre la pestaña “Cámara”', 'Concede permisos', 'Apunta al código hasta que se procese'],
        },
      ],
    },
    features: {
      title: 'Ventajas del escáner',
      items: [
        { title: 'Gratuito e ilimitado', desc: 'Sin bloqueos ni cuotas ocultas.' },
        { title: 'Multiformato', desc: 'Lee QR, Code 128, EAN, UPC, ITF, etc.' },
        { title: 'Privacidad total', desc: 'Los datos no salen de tu dispositivo.' },
      ],
    },
    useCases: {
      title: 'Casos de uso',
      items: [
        { title: 'Marketing y eventos', desc: 'Valida folletos, menús o entradas con QR.' },
        { title: 'Operaciones y logística', desc: 'Comprueba códigos de barras en inventarios.' },
        { title: 'Uso cotidiano', desc: 'Accede a Wi-Fi, catálogos o formularios de forma segura.' },
      ],
    },
    faq: {
      title: 'Dudas del escáner',
      items: [
        { q: '¿Lee códigos de barras?', a: 'Sí. Soporta los formatos lineales más usados.' },
        { q: '¿Puedo pegar capturas?', a: 'Sí, utiliza Ctrl+V (o Cmd+V en Mac) para pegar desde el portapapeles.' },
        { q: '¿Guardan mis resultados?', a: 'No. Los resultados quedan en tu dispositivo y puedes limpiarlos cuando quieras.' },
        { q: '¿Funciona sin conexión?', a: 'Las cargas funcionan offline; la cámara necesita permisos y soporte del navegador.' },
      ],
    },
  },
  blog: {
    title: 'Ideas y Guías',
    subtitle: 'Noticias, estrategias y mejores prácticas para tus campañas con QR.',
    readMore: 'Leer artículo',
    back: 'Volver al blog',
    notFound: 'Entrada no encontrada',
  },
  common: {
    footer: 'Suite completa para crear y analizar códigos QR profesionales.',
    privacy: 'Privacidad',
    terms: 'Términos',
    contact: 'Contacto',
    scanToOpen: 'Escanea para abrir en el móvil',
    help: 'Ayuda',
    free: 'Gratis',
    product: 'Producto',
    resources: 'Recursos',
    company: 'Empresa',
    api: 'API (próximamente)',
    systemStatus: 'Sistemas operativos',
    footerDesc:
      'El generador y escáner de QR más avanzado. Rápido, seguro y gratuito para proyectos personales y comerciales.',
  },
};
